import { useCallback, useRef } from 'react'
import type { Block, Variable, DemoBackground, DemoTheme } from './types'

export interface StateSnapshot {
  blocks: Block[]
  variables: Variable[]
  background?: DemoBackground
  theme?: DemoTheme
}

export function useUndoRedo() {
  const historyRef = useRef<StateSnapshot[]>([])
  const futureRef = useRef<StateSnapshot[]>([])

  const canUndo = historyRef.current.length > 0
  const canRedo = futureRef.current.length > 0

  const pushHistory = useCallback((snap: StateSnapshot) => {
    historyRef.current = [...historyRef.current.slice(-49), snap]
    futureRef.current = []
  }, [])

  const popUndo = useCallback((current: StateSnapshot): StateSnapshot | null => {
    if (historyRef.current.length === 0) return null
    futureRef.current = [...futureRef.current, current]
    const prev = historyRef.current[historyRef.current.length - 1]
    historyRef.current = historyRef.current.slice(0, -1)
    return prev
  }, [])

  const popRedo = useCallback((current: StateSnapshot): StateSnapshot | null => {
    if (futureRef.current.length === 0) return null
    historyRef.current = [...historyRef.current, current]
    const next = futureRef.current[futureRef.current.length - 1]
    futureRef.current = futureRef.current.slice(0, -1)
    return next
  }, [])

  return { canUndo, canRedo, pushHistory, popUndo, popRedo }
}
